import $ from 'jQuery';
import { calculatorJsonData } from './calculator-json';

const animationDuration = 500;

let jsonData;
const fetchJson = async (local = false) => {
    if (local === false) {
        try {
            const response = await fetch(SITE_PARAMS.site_url + '/wp-json/nzu/v1/calculator/data', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
            });
            jsonData = await response.json();
        } catch (e) {
            console.log(e);
        }
    } else {
        jsonData = calculatorJsonData;
    }
};

let values = {};
function initValues() {
    values = {};
    $('.calc-form-select').each(function () {
        $(this).prop('selectedIndex', 0);
        setValue(this);
    });
    $('.calc-form-checkbox').each(function () {
        $(this).prop('checked', false);
        setValue(this, true);
    });
}

function setValue(element, checkbox = false) {
    const $element = $(element);
    const id = $element.attr('id');

    if (checkbox === true && $element.prop('checked') === false) {
        values[id] = $element.data('default');
    } else {
        values[id] = JSON.parse(element.value);
    }

    calculateResult();
}

function resetResult() {
    initValues();
    calculateResult();
}

class CombinationElem {
    constructor() {
        this.hasCondition = false;
        this.withSelectors = {};
        this.withAnySelectors = {};
        this.restrictCount = 0;
        this.restrictSelectors = {};
        this.bonusCondition = false;
    }
}

class BonusElem {
    constructor() {
        this.bonusCondition = false;
        this.bonus = false;
    }
}

function calculateResult() {
    const docBonus = {
        a: 25000,
        b: 35000,
        c: 5000,
        d: 5000,
    };
    const enviroBonus = 25000;

    $('.select.mustCombine').removeClass('mustCombine');
    $('.checkbox.mustCombine').removeClass('mustCombine');
    let [median, doc, bonus, bonusCount] = [0, 0, 0, 0];
    let [aFlag, bFlag, cFlag, dFlag, enviroFlag] = [false, false, false, false, false];
    let combinations = {};
    let bonuses = {};
    let bonusesArray = [];
    let bonusCyclicalConditionalityCount = 0;

    let zatepleni = false;
    let vymenaZdroje = false;
    let teplaVoda = false;
    let fve = false;
    let odpadniTeplo = false;
    let rizeneVetrani = false;
    // let zatepleniCheckbox = false;
    // let boilerBonus = 0;
    let energetickyStandard = false;
    let stiniciTechnikaHidden = false;

    let bonusRegion = $('#checkbox_region').is(':checked');
    let selectedZatepleni = $("#select_Zateplení").find(":selected").data("id");

    let selectedEnergetickyStandard = $("#select_Energetickýstandarddomu").find(":selected").data("id");

    if (selectedZatepleni === 4) {
        $("#checkbox_Stínícítechnika").prop("checked", false);
        delete values["checkbox_Stínícítechnika"];

        $("#checkbox_Stínícítechnika_wrapper").hide();
        stiniciTechnikaHidden = true;
    } else {
        $("#checkbox_Stínícítechnika_wrapper").show();
        stiniciTechnikaHidden = false;
    }

    if (selectedZatepleni === 4 || selectedEnergetickyStandard) {
        $("#select_Rodinnýbonus_wrapper").show();
    } else {
        $("#select_Rodinnýbonus_wrapper").hide();
    }

    let selectedRodinnyBonus = $("#select_Rodinnýbonus").find(":selected").data("id");

    Object.entries(values).forEach((element) => {
        const [key, value] = element;
        
        value.combine.forEach((subelement) => {
            if (subelement.key){
                if (!(subelement.key in combinations)) {
                    combinations[subelement.key] = new CombinationElem();
                }
            } else {
                subelement.keys.forEach((subkey) => {
                    if (!(subkey in combinations)) {
                        combinations[subkey] = new CombinationElem();
                    }
                });
            }

            if (key == 'select_Zateplení') {
                zatepleni = true;
                // boilerBonus = value.boilerBonus;
            }
            if (key == 'checkbox_Spolusdotacínazateplenívyužijikotlíkovoudotaciprodomácnostsnižšímipříjmy') {
                // zatepleniCheckbox = true;
            }
            if (key == 'select_Výměnazdrojetepla') {
                vymenaZdroje = true;
            }
            if (key == 'select_Přípravateplévody') {
                teplaVoda = true;
            }
            if (key == 'select_Domácífotovoltaickáelektrárna') {
                fve = true;
            }
            if (key == 'select_Teplozodpadnívody') {
                odpadniTeplo = true;
            }
            if (key == 'select_Systémřízenéhovětrání') {
                rizeneVetrani = true;
            }

            if (key == 'select_Energetickýstandarddomu') {
                energetickyStandard = true;
            }

            switch (subelement.type) {
                case 'condition':
                    combinations[subelement.key].hasCondition = true;
                    break;
                case 'with':
                    combinations[subelement.key].withSelectors['#' + key] = subelement.error;
                    break;
                case 'withAny':
                    subelement.keys.forEach((subkey) => {
                        combinations[subkey].withAnySelectors['#' + subkey] = subelement.error;
                    });
                    break;
                case 'restrict':
                    combinations[subelement.key].restrictCount += 1;
                    combinations[subelement.key].restrictSelectors['#' + key] = subelement.error;
                    break;
                case 'bonusCondition':
                    combinations[subelement.key].bonusCondition = true;

                    if (!(key in bonuses)) {
                        bonuses[key] = new BonusElem();
                    }
                    bonuses[key].bonusCondition = subelement.key;
                    break;
            }
        });
    });
    Object.entries(values).forEach((element) => {
        const [key, value] = element;

        let canContinue = true;
        let hasBonus = false;
        let requiredWithAnySelected = false;

        value.combine.forEach((subelement) => {
            switch (subelement.type) {
                case 'with':
                    if (combinations[subelement.key].hasCondition === false) {
                        canContinue = false;
                    }
                    break;
                case 'restrict':
                    if (combinations[subelement.key].restrictCount >= 2) {
                        canContinue = false;
                    }
                    break;
                case 'bonus':
                    if (combinations[subelement.key].bonusCondition === true) {
                        hasBonus = true;

                        if (!(key in bonuses)) {
                            bonuses[key] = new BonusElem();
                        }
                        bonuses[key].bonus = subelement.key;
                    }
                    break;
                case 'withAny':
                    let hasAnySelected = false;                  
                    
                    subelement.keys.forEach((requiredKey) => {
                        if (combinations[requiredKey].hasCondition === true) {
                            hasAnySelected = true;
                        }
                    });
                    
                    if (!hasAnySelected) {
                        canContinue = false;
                        requiredWithAnySelected = true;
                    }
                    break;
            }
        });

        if (canContinue === true) {
            median += value.median;

            switch (String(value.grantType).toLowerCase()) {
                case 'a':
                    aFlag = true;
                    break;
                case 'b':
                    bFlag = true;
                    break;
                case 'c':
                    cFlag = true;
                    break;
                case 'd':
                    dFlag = true;
                    break;
                case 'enviro':
                    enviroFlag = true;
                    break;
                default:
                    break;
            }

            if (hasBonus === true) {
                bonusCount += 1;
            }
        }

        if (requiredWithAnySelected) {
            let error;
            const [key, value] = element;

            value.combine.forEach((el) => {
                if (el.type == 'withAny') {
                    error = el.error;
                }
            });
            
            $(`#${key}`).closest('.calc-form-item').addClass('mustCombine').children('.combine-error').html(error);
        } else {
            $(`#${key}`).closest('.calc-form-item').removeClass('mustCombine');
        }
    });

    Object.entries(bonuses).forEach((element) => {
        const [key, value] = element;

        if (value.bonusCondition !== false && value.bonus !== false) {
            bonusesArray.push(value);
        }
    });

    for (let i = 0; i < bonusesArray.length; i++) {
        for (let j = i + 1; j < bonusesArray.length; j++) {
            if (bonusesArray[i].bonusCondition === bonusesArray[j].bonus && bonusesArray[i].bonus === bonusesArray[j].bonusCondition) {
                bonusCyclicalConditionalityCount++;
            }
        }
    }

    if (aFlag) {
        doc += docBonus.a;
    }
    if (bFlag) {
        doc += docBonus.b;
    }
    if (cFlag) {
        doc += docBonus.c;
    }
    if (dFlag) {
        doc += docBonus.d;
    }
    if (enviroFlag) {
        bonus += enviroBonus;
    }

    if (zatepleni) {
        if ([1, 2, 3].includes(selectedZatepleni)) {
            if (vymenaZdroje) {
                bonus += 30000;
            }
            if (teplaVoda || fve || rizeneVetrani || odpadniTeplo) {
                bonus += 30000;
            }
        } else if (selectedZatepleni === 4) {
            if (vymenaZdroje) {
                bonus += 50000;
            }
            if (teplaVoda || fve || rizeneVetrani || odpadniTeplo) {
                bonus += 50000;
            }
        }

        if (selectedRodinnyBonus === 1) {
            bonus += 50000;
        } else if (selectedRodinnyBonus === 2) {
            bonus += 100000;
        }
    }

    if (energetickyStandard) {
        if (selectedRodinnyBonus === 1) {
            bonus += 50000;
        } else if (selectedRodinnyBonus === 2) {
            bonus += 100000;
        }
    }
    
    // if (median > 20000) {
    //     bonus += (bonusCount - bonusCyclicalConditionalityCount) * 10000;
    //     // if (zatepleni && zatepleniCheckbox) {
    //     //     bonus += boilerBonus;
    //     // }
    // }
    // if ((bonusRegion && zatepleni) || (bonusRegion && energetickyStandard)) {
    if (bonusRegion) {
        median *= 1.05;
        doc *= 1.05;
    }
    // if (zatepleni && fve) {
    //     bonus += 30000;
    // }

    // $('#sum').html((median + doc + bonus).toLocaleString());
    $('#sum').html((median + bonus).toLocaleString());
    $('#median').html(median.toLocaleString());
    // $('#doc').html(doc.toLocaleString());
    $('#bonus').html(bonus.toLocaleString());

    Object.entries(combinations).forEach((element) => {
        const [key, value] = element;
        
        if (value.hasCondition === false) {
            Object.entries(value.withSelectors).forEach((element) => {
                const [key, value] = element;
                $(key).closest('.calc-form-item').addClass('mustCombine').children('.combine-error').html(value);
            });
        }
        if (value.restrictCount >= 2) {
            Object.entries(value.restrictSelectors).forEach((element) => {
                const [key, value] = element;
                $(key).closest('.calc-form-item').addClass('mustCombine').children('.combine-error').html(value);
            });
        }
    });
}

function handleMenuClick(button) {
    $('.calculator__menu_btn.active').removeClass('active');
    $(button).addClass('active');

    $('.calculator__result').fadeIn();
    let key = $(button).data('value');

    let element = $('.calculator__content');
    let data = {
        data: jsonData[key],
        key: key,
    };

    renderForm(element, data);
}

const getCalcForm = async (data) => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/nzu/v1/calculator/html', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(data),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};

const renderForm = async (element, filter) => {
    const data = await getCalcForm(filter);
    $(element).html(data.html);
    initValues();
};

$(function () {
    if ($('.calculator')[0] != undefined) {
        fetchJson(false).then(function () {
            // delete true or change to false for data from API...
            handleMenuClick($('.calculator__menu_btn').first());

            $('.calculator__menu_btn').on('click', function () {
                handleMenuClick(this);
                $('html, body')
                    .stop()
                    .animate(
                        {
                            scrollTop: $('.calculator__body').offset().top - 130,
                        },
                        animationDuration
                    );
            });

            $(document).on('change', '.calc-form-select', function () {
                setValue(this);
            });
            $(document).on('change', '.calc-form-checkbox', function () {
                setValue(this, true);
            });

            $(document).on('change', '#checkbox_region', function () {
                calculateResult();
            });

            $(document).on('click', '#calculator__reset', function () {
                resetResult();
                $('#checkbox_region').prop('checked', false);
            });
        });
    }
});
